import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { mediaTablet } from '../styles/breakpoints';
import { sharpImageRendering } from '../styles/images';

import Image from './Grafik_Download.svg';

const Container = styled.div`
  text-align: center;
  padding: 30px;
`;

const ContainerInsideCTA = css`
  overflow: hidden;
  text-align: center;
  padding: 0 !important;

  height: 200px;

  ${mediaTablet} {
    height: 190px;
  }
`;

const Img = styled.img`
  ${sharpImageRendering}
  max-width: 100%;
`;

const GrafikPDFDownload = ({ insideCTA }) => (
  <Container className={insideCTA ? ContainerInsideCTA : ''}>
    <Img
      src={Image}
      alt="Grafik PDF Download"
    />
  </Container>
);

GrafikPDFDownload.propTypes = {
  insideCTA: PropTypes.bool,
};

GrafikPDFDownload.defaultProps = {
  insideCTA: false,
};

export default GrafikPDFDownload;



// WEBPACK FOOTER //
// ./src/components/GrafikPDFDownload/GrafikPDFDownload.js